// REACT & Libraries
import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import DataTable from "react-data-table-component";
import FilterComponent from "../../Common/FilterComponent";

// Table
import { ProvinceTableColumn } from "../../../../Data/DataTables/Province";

// Types
import { ViewProvince } from "../../../../Types/MasterData/Province";

// Services
import {
  VIEW_PROVINCE_QUERY_KEY,
  provinceService,
} from "../../../../Services/provinceService";

const ProvinceTable = () => {
  const [filterText, setFilterText] = useState("");
  const { data: dataResponse, isLoading } = useQuery({
    queryKey: VIEW_PROVINCE_QUERY_KEY,
    queryFn: provinceService.getAllProvinces,
  });

  const filteredItems: ViewProvince[] =
    dataResponse?.filter((item: ViewProvince) =>
      Object.values(item).some(
        (value) =>
          value &&
          value.toString().toLowerCase().includes(filterText.toLowerCase()),
      ),
    ) ?? [];

  const customStyles = {
    rows: {
      style: {
        whiteSpace: "nowrap",
      },
    },
    cells: {
      style: {
        whiteSpace: "nowrap",
        marginTop: "8px",
        marginBottom: "8px",
      },
    },
  };

  return (
    <>
      <FilterComponent
        onFilter={(e: React.ChangeEvent<HTMLInputElement>) =>
          setFilterText(e.target.value)
        }
        filterText={filterText}
      />
      <div className="table-responsive">
        <DataTable
          className="display nowrap custom-scrollbar"
          data={filteredItems}
          columns={ProvinceTableColumn}
          striped={true}
          pagination
          progressPending={isLoading}
          highlightOnHover={true}
          fixedHeader={true}
          customStyles={customStyles}
        />
      </div>
    </>
  );
};

export default ProvinceTable;
